class PeopleSingle {
  constructor() {
    document.querySelectorAll('.js-people-swiper-other').forEach((swiperEl) => {
      const section = swiperEl.closest('.js-people-swiper-section');
      if (!section || swiperEl.swiper) {
        return;
      }

      const prevEl = section.querySelector('.js-people-other-prev');
      const nextEl = section.querySelector('.js-people-other-next');
      const nowEl = section.querySelector('.js-people-other-now');
      const totalEl = section.querySelector('.js-people-other-total');

      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      if (!wrapper) {
        return;
      }

      const originalSlides = Array.from(wrapper.children);
      const slideCount = Number(swiperEl.dataset.slideCount) || originalSlides.length;
      if (slideCount <= 2) {
        return;
      }

      const enableLoop = slideCount > 1;

      const slidesPerViewPc = Number(swiperEl.dataset.slidesPerViewPc);
      const hasPcSlidesPerView = Number.isFinite(slidesPerViewPc) && slidesPerViewPc > 0;

      const syncSlideWidths = () => {
        const isSp = window.matchMedia('(max-width: 767px)').matches;
        if (!isSp && hasPcSlidesPerView) {
          swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
            slide.style.width = '';
            slide.style.maxWidth = '';
          });
          return;
        }

        const widthPc = swiperEl.dataset.slideWidthPc || '36rem';
        const widthSp = swiperEl.dataset.slideWidthSp || '32rem';
        const width = isSp ? widthSp : widthPc;

        swiperEl.querySelectorAll('.swiper-slide').forEach((slide) => {
          slide.style.width = width;
        });
      };

      if (enableLoop) {
        originalSlides.forEach((slide) => {
          wrapper.appendChild(slide.cloneNode(true));
        });
        originalSlides.forEach((slide) => {
          wrapper.appendChild(slide.cloneNode(true));
        });
      }

      syncSlideWidths();

      const getLogicalIndex = (swiper) => swiper.activeIndex % slideCount;

      const fixPosition = (swiper) => {
        const index = swiper.activeIndex;

        if (index < slideCount) {
          swiper.slideTo(index + slideCount, 0);
          return;
        }

        if (index >= slideCount * 2) {
          swiper.slideTo(index - slideCount, 0);
        }
      };

      const updatePagination = (swiper) => {
        if (!nowEl || !totalEl) {
          return;
        }

        totalEl.textContent = String(slideCount).padStart(2, '0');
        const current = enableLoop ? getLogicalIndex(swiper) + 1 : swiper.activeIndex + 1;
        nowEl.textContent = String(current).padStart(2, '0');
      };

      const swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 20,
        speed: 500,
        loop: false,
        initialSlide: enableLoop ? slideCount : 0,
        watchOverflow: slideCount <= 1,
        breakpoints: {
          768: {
            spaceBetween: 40,
            ...(hasPcSlidesPerView
              ? {
                  slidesPerView: Math.min(slidesPerViewPc, slideCount),
                  centeredSlides: false,
                }
              : {}),
          },
        },
        on: {
          init() {
            syncSlideWidths();
            this.update();
            updatePagination(this);
          },
          resize() {
            syncSlideWidths();
            this.update();
          },
          slideChangeTransitionEnd() {
            if (enableLoop) {
              fixPosition(this);
            }
            updatePagination(this);
          },
        },
      });

      if (prevEl) {
        prevEl.addEventListener('click', (event) => {
          event.preventDefault();
          swiper.slidePrev();
        });
      }

      if (nextEl) {
        nextEl.addEventListener('click', (event) => {
          event.preventDefault();
          swiper.slideNext();
        });
      }

      swiperEl.swiper = swiper;
    });
  }
}
